import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export interface IInquiryPayload {
  category_id: number;
  service_id: number;
  required_data: Record<string, any>;
  top_up?: boolean;
}

export const inquiryPayment = (payload: IInquiryPayload) => {
  const { top_up, ...rest } = payload;

  return axiosPrivate.post(`/bills/api/v1/inquiry/${top_up ? '?top_up=true' : ''}`, rest);
};
